import React from 'react';
import { Handle, Position } from 'reactflow';
import './ConditionNode.css';

const ConditionNode = ({ data, selected }) => {
  const getSubtitle = () => {
    const config = data?.config || {};
    const conditionType = config.condition_type || 'simple';

    if (conditionType === 'always_true') {
      return 'Sempre Verdadeiro';
    } else if (conditionType === 'always_false') {
      return 'Sempre Falso';
    } else if (conditionType === 'simple') {
      const operator = config.operator || 'equals';
      const operatorLabels = {
        equals: 'Igual (=)',
        not_equals: 'Diferente (≠)',
        contains: 'Contém',
        not_contains: 'Não contém',
        starts_with: 'Começa com',
        ends_with: 'Termina com',
        greater_than: 'Maior (>)',
        less_than: 'Menor (<)',
        greater_or_equal: 'Maior/Igual (≥)',
        less_or_equal: 'Menor/Igual (≤)',
        is_empty: 'Vazio',
        is_not_empty: 'Não vazio',
        regex_match: 'Regex',
      };
      return operatorLabels[operator] || operator;
    } else if (conditionType === 'multiple') {
      const conditionsCount = (config.conditions || []).length;
      const operation = config.combine_operation || 'AND';
      const operationLabel = operation === 'AND' ? 'E' : 'OU';
      return `${conditionsCount} condições (${operationLabel})`;
    } else if (conditionType === 'expression') {
      return 'Expressão customizada';
    }

    return 'Configurar condição';
  };

  const color = '#f39c12';

  return (
    <div
      className={`workflow-node-wrap ${selected ? 'workflow-node-wrap--selected' : ''}`}
      style={{ '--node-color': color }}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="workflow-node__handle workflow-node__handle--left"
      />

      <div className="workflow-node-box">
        <span className="workflow-node__icon-badge">
          <i className="bi bi-diagram-3" />
        </span>
      </div>

      <div className="workflow-node-meta">
        <div className="workflow-node__label">Condição</div>
        <div className="workflow-node__subtitle">{getSubtitle()}</div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="if_true"
        className="workflow-node__handle workflow-node__handle--right-true"
        style={{ top: '25px' }}
      />
      <span className="condition-label condition-label--true">CERTO</span>

      <Handle
        type="source"
        position={Position.Right}
        id="if_false"
        className="workflow-node__handle workflow-node__handle--right-false"
        style={{ top: '47px' }}
      />
      <span className="condition-label condition-label--false">FALSO</span>
    </div>
  );
};

export default ConditionNode;
